import React from 'react';
import { useLocation } from 'react-router-dom';
import { useCredit } from '../contexts/CreditContext';
import ProfessionalSubscriptionPopup from './ProfessionalSubscriptionPopup';

const CreditManager: React.FC = () => {
  const location = useLocation();
  const { 
    showLowCreditPopup, 
    setShowLowCreditPopup, 
    isBlocked 
  } = useCredit();

  // Não mostrar popup na página de checkout e evitar múltiplas renderizações
  const shouldShowPopup = showLowCreditPopup && 
                          location.pathname !== '/checkout' &&
                          !location.pathname.includes('/admin');
  
  const handleClose = () => {
    setShowLowCreditPopup(false);
  };

  return (
    <ProfessionalSubscriptionPopup
      open={shouldShowPopup}
      onClose={handleClose}
      isBlocked={isBlocked}
    />
  );
};

export default CreditManager; 